import Section from "../Section";


export default function About() {
    return <Section title='About'>
        <p className="text">
        I am a <span className="text -bold">result-driven software engineer</span> - proficient in designing and building scalable full-stack web applications.
        My expertise lie in architecting end-to-end workflows, using React, Javascript and Python. I have also worked on novel projects to design and develop <span className="text -bold">content recommendation engine</span> powered by embedding models. 
        Beyond AI and full-stack applications, I have a background in building interactive design tools including an innovative <span className="text -bold">HTML editor</span>. 
        <br/>
        <br/>
        I am also an avid developer and gamer. I like to dedicate my free time to playing and building multiplayer games.
    </p>
    </Section>;
};